!function(){
  function e(){
    subSliderInit(!0),
    sliderInit(!0),
    popupSliderInit(!0);

    // ✅ Unser Zusatz: Haupt-Swiper global machen
    const galleryEl = document.querySelector(".product__media .swiper");
    if (galleryEl && galleryEl.swiper) {
      window.productSwiper = galleryEl.swiper;
      console.log("✅ productSwiper global verfügbar:", window.productSwiper);
    }
  }

  function i(e,t){
    var o=e.clientHeight;
    e.style.transitionProperty="height, margin, padding",
    e.style.transitionDuration=t+"ms",
    e.style.boxSizing="border-box",
    e.style.overflow="hidden",
    e.style.height=o+"px",
    e.style.paddingTop="0",
    e.style.paddingBottom="0",
    e.style.marginTop="0",
    e.style.marginBottom="0",
    setTimeout(function(){
      e.style.height="0",
      e.style.paddingTop="0",
      e.style.paddingBottom="0",
      e.style.marginTop="0",
      e.style.marginBottom="0"
    },10),
    setTimeout(function(){
      e.style.display="none",
      e.style.removeProperty("height"),
      e.style.removeProperty("padding-top"),
      e.style.removeProperty("padding-bottom"),
      e.style.removeProperty("margin-top"),
      e.style.removeProperty("margin-bottom"),
      e.style.removeProperty("overflow"),
      e.style.removeProperty("transition-duration"),
      e.style.removeProperty("transition-property")
    },t)
  }

  const t=()=>{ /* … dein Accordion Code … */ },
        o=()=>{ /* … dein Button Observer Code … */ };

  class r extends ModalDialog {
    constructor(){ super() }
    hide(){ super.hide(),window.pauseAllMedia() }
    show(e){ super.show(e),this.showActiveMedia() }
    showActiveMedia(){
      var e=this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      "DEFERRED-MEDIA"==e.nodeName&&e.querySelector("template")?.content?.querySelector(".js-youtube")&&e.loadContent()
    }
  }

  customElements.define("product-modal",r),
  document.addEventListener("shopify:section:load",function(){t(),o(),e()}),
  e(),t(),o()
}();
